<template>
  <el-dialog
    :title="$t('allocationOrder.editAllocation')"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('allocationOrder.orderId')">
        <el-input v-model="formData.orderId" disabled />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.productName')">
        <el-input v-model="formData.prodName" disabled />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.specName')">
        <el-input v-model="formData.specName" disabled />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.srcShop')">
        <el-input v-model="formData.shopName" disabled />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.srcWarehouse')">
        <el-input v-model="formData.srcShName" disabled />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.targetWarehouse')" prop="targetShId" required>
        <el-select
          v-model="formData.targetShId"
          :placeholder="$t('allocationOrder.selectTargetWarehouse')"
          style="width:100%"
        >
          <el-option
            v-for="(item,index) in shopHouses"
            :key="index"
            :label="item.shName"
            :value="item.shId"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.productCount')" prop="productCount" required>
        <el-input v-model.number="formData.productCount" type="number" />
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.status')">
        <el-input v-model="formData.stateName" disabled />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAllocationOrder, queryShopHouse } from '@/api/goods/allocationOrderApi'

export default {
  name: 'AllocationOrderEdit',
  data() {
    return {
      dialogVisible: false,
      formData: {
        productId: '',
        specId: '',
        prodName: '',
        specName: '',
        shopName: '',
        srcShName: '',
        targetShopName: '',
        targetShName: '',
        productCount: '',
        shId: '',
        orderId: '',
        srcShId: '',
        targetShId: '',
        staffName: '',
        state: '',
        stateName: '',
        shopId: ''
      },
      shopHouses: []
    }
  },
  methods: {
    open(params) {
      this.resetForm()
      this.formData = { ...params }
      this.dialogVisible = true
      this.getShopHouses(params.srcShId)
    },
    close() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    },
    resetForm() {
      this.formData = {
        productId: '',
        specId: '',
        prodName: '',
        specName: '',
        shopName: '',
        srcShName: '',
        targetShopName: '',
        targetShName: '',
        productCount: '',
        shId: '',
        orderId: '',
        srcShId: '',
        targetShId: '',
        staffName: '',
        state: '',
        stateName: '',
        shopId: ''
      }
    },
    async getShopHouses(shId) {
      try {
        const res = await queryShopHouse({
          shopId: this.formData.shopId,
          shId: shId,
          flag: '1',
          page: 1,
          row: 50
        })
        this.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库失败:', error)
      }
    },
    validateForm() {
      if (!this.formData.targetShId) {
        this.$message.error(this.$t('allocationOrder.selectTargetWarehouseRequired'))
        return false
      }
      if (!this.formData.productCount || this.formData.productCount <= 0) {
        this.$message.error(this.$t('allocationOrder.productCountRequired'))
        return false
      }
      return true
    },
    async submit() {
      if (!this.validateForm()) return
      
      try {
        await updateAllocationOrder(this.formData)
        this.$emit('listAssetInventory')
        this.$message.success(this.$t('common.updateSuccess'))
        this.close()
      } catch (error) {
        console.error('更新失败:', error)
        this.$message.error(error.message)
      }
    }
  }
}
</script>